import { Product } from "@common/enums/Product.ts";
import { parse } from 'tldts';

export class Config {

    constructor(
        public readonly environment: string,
        public readonly useNMI: boolean,
        public readonly productOverride: Product,
        public readonly stripeSellersPk: string,
        public readonly stripeClientsPk: string,
        public readonly stripePicklePk: string,
        public readonly sentryDsn: string
    ) {}

    // returns the server url for the given client url
    serverBaseUrl(clientUrl: string): string {
        // This allows explicit API URL for compass
        const override = import.meta.env.VITE_COMPASS_SERVER_URL;
        if (override) {
            return override;
        }

        const url = parse(clientUrl);
        if (this.environment === 'staging') {
            return `https://api.staging.${url.domain!}`;
        } else if (this.environment === 'production') {
            return `https://api.${url.domain!}`;
        } else {
            const scheme = clientUrl.startsWith('https') ? 'https' : 'http';
            const host = url.domain != null && !url.domain.includes('localhost') ? `api.${url.domain}` : 'localhost';
            // allow some flexibility in the url for development
            return `${scheme}://${host}:5005`;
        }
    }
}

const environment = import.meta.env.VITE_ENVIRONMENT!;
const useNMI = (import.meta.env.VITE_USE_NMI_OVERRIDE === 'true' || import.meta.env.VITE_USE_NMI === 'true');
const productOverride = import.meta.env.VITE_PRODUCT_OVERRIDE as Product;

const stripeSellersPk = import.meta.env.VITE_SELLERS_STRIPE_CLIENT_KEY;
const stripeClientsPk = import.meta.env.VITE_CLIENTS_STRIPE_CLIENT_KEY;
const stripePicklePk = import.meta.env.VITE_PICKLE_STRIPE_CLIENT_KEY;
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

const config = new Config(environment, useNMI, productOverride, stripeSellersPk, stripeClientsPk, stripePicklePk, sentryDsn);
export default config;
